import { render, staticRenderFns } from "./DiceOne.vue?vue&type=template&id=6a9c9abc&scoped=true&"
import script from "./DiceOne.vue?vue&type=script&lang=js&"
export * from "./DiceOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c9abc",
  null
  
)

export default component.exports